import { Component, OnInit, OnDestroy, ContentChild, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BusAuctionFilterService } from '../../../home/services/bus-auction-filter.service';
import { DataTableDirective } from 'angular-datatables';
import { AuctionFilter } from '../../../home/models/auction-filter';
import { MessagePopupComponent } from '../../../modal-window/message-popup/message-popup.component';
import { min } from 'rxjs/operators';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
const apiControl = '/mailing';

declare var $: any;

@Component({
  selector: 'app-mailing-page',
  templateUrl: './mailing-page.component.html',
  styleUrls: ['./mailing-page.component.sass']
})



export class MailingPageComponent implements OnInit, OnDestroy {

  private subs: any[] = [];
  dataSetExportImportTable: any;
  dtOptionsExportImportTable: DataTables.Settings = {};
  dataSetRegions: any;
  checkedRegion: string[];
  checkedDistributorNumber: string[];
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  spinner: NgxSpinnerService;
  defaultDateFrom: string;
  defaultDateTo: string;

  dt: DataTables.Api;

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('regionCheckInput') nameInputModel: QueryList<any>;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private _spinner: NgxSpinnerService, private loggingService: LoggingService) {
    this.dataSetExportImportTable = [];
    this.checkedRegion = [];
    this.checkedDistributorNumber = [];
    this.spinner=_spinner;
    this.defaultDateFrom = this.getDateYYYYMMDD();
    this.defaultDateTo = this.getDateYYYYMMDD(true);
  }


  ngOnInit() {
    this.spinner.show();

    
    this.subs.push(this.bus.currentFilter$.subscribe(filter => {
      this.modelAuctionFilter = filter;
      if (this.dt != null) {
        this.onFieldChange();
      }
    }));
    
    $('.datetimepickers').each(function () {
      $(this).datetimepicker({
        locale: 'ru',
        format: 'YYYY-MM-DD',
        collapse: true,
        keepOpen: false,
        useCurrent: false,
        showClear: false
      });
    });
    
    this.modelAuctionFilter.participant = { value: "all", name:"Все"};

    $('#dateAucFrom').val(this.defaultDateFrom); 
    this.modelAuctionFilter.dateAucFrom = this.defaultDateFrom;

    $('#dateAucTo').val(this.defaultDateTo); 
    this.modelAuctionFilter.dateAucTo = this.defaultDateTo;


    this.dtOptionsExportImportTable = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: false,
      autoWidth: true,
      paging: true,
      info: false,
      orderCellsTop: true,
      scrollY: 'calc(100vh - 420px)',

      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        this.spinner.hide();

        dataTablesParameters.regionName = this.modelAuctionFilter.region;
        dataTablesParameters.customerName = this.modelAuctionFilter.contractor;
        dataTablesParameters.Mnn = this.modelAuctionFilter.mnn;
        dataTablesParameters.SumFrom = this.modelAuctionFilter.sumFrom;
        dataTablesParameters.SumTo = this.modelAuctionFilter.sumTo;
        this.modelAuctionFilter.dateAucFrom = ( this.modelAuctionFilter.dateAucFrom == "") ? this.defaultDateFrom :  this.modelAuctionFilter.dateAucFrom;
        this.modelAuctionFilter.dateAucTo = ( this.modelAuctionFilter.dateAucTo == "") ? this.defaultDateTo :  this.modelAuctionFilter.dateAucTo;
        
        if(new Date(this.modelAuctionFilter.dateAucFrom) < new Date(this.modelAuctionFilter.dateAucTo)){
          dataTablesParameters.dtFrom = this.modelAuctionFilter.dateAucFrom;
          dataTablesParameters.dtTo = this.modelAuctionFilter.dateAucTo;
        }else{
          dataTablesParameters.dtFrom = this.modelAuctionFilter.dateAucTo;
          dataTablesParameters.dtTo = this.modelAuctionFilter.dateAucFrom;
        }
        dataTablesParameters.status = this.modelAuctionFilter.statusItem.value;
        dataTablesParameters.addSign = this.modelAuctionFilter.addSign;
        dataTablesParameters.participant = this.modelAuctionFilter.participant.value;
        dataTablesParameters.search = this.modelAuctionFilter.search;

        this.http.post<any>(apiServer + apiControl, dataTablesParameters, {})
        .subscribe(resp => {
          if(resp != null){
              this.dataSetRegions = resp.data;
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
            }
            this.spinner.hide();
          });
      },
      order: [[0, "asc"]],
      columnDefs: [
        {
          orderable: false,
          className: 'select-checkbox',
          targets: 1
        },{
          orderable: false,
          targets: 2
        },{
          orderable: false,
          targets: 11
        }
      ],
    };
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
    
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  afterNgFor(){
    $('#exportImportTable').DataTable().columns.adjust();
    $('[data-toggle="popover"]').popover();
  }

  // Begin: Методы фильтров

  onClearDateFields(key: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.onClearDateFields', null, 'Clear date fields started');
      
      Object.keys(this.modelAuctionFilter).forEach(name => {
        if (name === key && this.modelAuctionFilter[name] != null) {
          switch (name) {
            case 'dateAucFrom':
                this.modelAuctionFilter[name] =  this.defaultDateFrom;
              break;
            case 'dateAucTo':
                this.modelAuctionFilter[name] =  this.defaultDateTo;
              break;
          
            default:
              this.modelAuctionFilter[name] = null;
              break;
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.onClearDateFields', null, 'Clear date fields completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.onClearDateFields', _error, null, 'Clear date fields failed');
      throw _error;
    }
  }

  onFieldChange(): void {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      this.dataSetExportImportTable = [];
      this.spinner.show();
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  onSelectedRow(event, value, distributorNumber) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.onSelectedRow', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedRegion.push(value);
        this.checkedDistributorNumber.push(distributorNumber);
      } else {
        for (let i = 0; i < this.checkedRegion.length; i++) {
          if (this.checkedRegion[i] === value) {
            this.checkedRegion.splice(i, 1);
            this.checkedDistributorNumber.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.onSelectedRow', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.onSelectedRow', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectingRows(event) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.onSelectingRows', null, 'Selecting all rows started');
      
      const that = this;

      this.nameInputModel.forEach(function (item) {
        item.nativeElement.checked = event.target.checked;

        if (event.target.checked) {
          that.checkedRegion.push(item.nativeElement.value);
          that.checkedDistributorNumber.push(item.nativeElement.distributorNumber);
        } else {
          for (let i = 0; i < that.checkedRegion.length; i++) {
            if (that.checkedRegion[i] === item.nativeElement.value) {
              that.checkedRegion.splice(i, 1);
              that.checkedDistributorNumber.splice(i, 1);
            }
          }
        }
      });
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.onSelectingRows', null, 'Selecting all rows completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.onSelectingRows', _error, null, 'Selecting all rows failed');
      throw _error;
    }
  }

  onClearModal(key: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.onClearModal', null, 'Clear modal started');
      
      this.bus.changeClearModalFilter(key);
      
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.onClearModal', null, 'Clear modal completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.onClearModal', _error, null, 'Clear modal failed');
      throw _error;
    }
  }

  onDateChange(event) {
    this.modelAuctionFilter[event.target.name] = event.target.value;
  }

  // Begin: Методы фильтров

  applyfilter() {
    const _xid = this.loggingService.generateUUID();
    try {
      this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.applyfilter', null, 'Apply filter started');
      this.spinner.show();
      this.dt.ajax.reload();
      this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.applyfilter', null, 'Apply filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.applyfilter', _error, null, 'Apply filter failed');
      throw _error;
    }
  }

  sendMail(){
    const _xid = this.loggingService.generateUUID();
    this.loggingService.logStart(_xid, 'App.Components.MailingPageComponent.sendMail', null, 'Send mail started');
    
    this.spinner.show();
    this.http.post<boolean>(apiServer + "/SendMailList", 
      { aucList: this.checkedRegion, 
        distributorNumberList: this.checkedDistributorNumber, 
        email: this.modelAuctionFilter.email, 
        addSign: this.modelAuctionFilter.addSign, 
        participant: "all"}).subscribe(resp => {
          var modal = $('#messageModal');
          if(resp != null && resp == true){
            modal.find('.mailBody').text(this.checkedRegion);
            modal.find('.modal-title').text("КП отправлены");
            this.loggingService.logFinish(_xid, 'App.Components.MailingPageComponent.sendMail', null, 'Send mail completed');
          }
          else{
            modal.find('.mailBody').text("Ошибка отправки");
            modal.find('.modal-title').text("Ошибка");
            this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.sendMail', { error: 'Send failed' }, null, 'Send mail failed');
          }
          modal.show();
        this.spinner.hide();
      }, error => {
        this.loggingService.logError(_xid, 'App.Components.MailingPageComponent.sendMail', error, null, 'Send mail error');
        this.spinner.hide();
      });
  }
  
    @ContentChild(MessagePopupComponent)
    m: MessagePopupComponent;
  
  mailtext(item){
    if(item.text != null)
    {
      var modal = $('#messageModal');
      modal.find('.mailBody').text(item.text.replace(/br/g, "\r\n"));
      modal.find('.modal-title').text("Отправлено " + item.dateAuc);
      modal.show();
    }
    else{
      this.http.get<Array<string>>(apiServer + "/commercial_offer/"+ item.idAuc + "/" + "1" + "/" + 1)
      .subscribe(resp => { 
  
        var modal = $('#messageModal');
        modal.find('.mailBody').text(resp["mailBody"]);
        modal.find('.modal-title').text("Получатель " + resp["mailTo"]);
        modal.show();
      });
    }
  }

  aucText(item){
    if(item != null)
    {
      var modal = $('#messageModal');
      var text = item.dateAuc + "\r\n" + 
                item.regionName + "\r\n" + 
                item.customerName + "\r\n" + 
                item.sumAuc.toString().split(',').join(' ') + "\r\n" + 
                item.amountPosition + " SKU";
      modal.find('.mailBody').text(text);
      modal.find('.modal-title').text(item.idAuc);
      modal.show();
    }
  }

  getItemContent(item){
    return `The content is ${item.text} some other text`
  }

  getItemTitle(item){return `The content is ${item.text} some other text`}

  onSelectedStatus(event){
    switch (event) {
      case "all":
        this.modelAuctionFilter.statusItem = { value: "all", name:"Все"};
        break;
        case "new":
        this.modelAuctionFilter.statusItem = { value: "new", name:"Только новые"};
        break;
        case "sent":
        this.modelAuctionFilter.statusItem = { value: "sent", name:"Уже отправленные"};
        break;
    
      default:
        this.modelAuctionFilter.statusItem = { value: "all", name:"Все"};
        break;
    }

  }

  onSelectedCP(event){
    switch (event) {
      case "all":
        this.modelAuctionFilter.participant = { value: "all", name:"Все"};
        break;
        case "new":
        this.modelAuctionFilter.participant = { value: "first", name:" 1"};
        break;
        case "sent":
        this.modelAuctionFilter.participant = { value: "second", name:" 2"};
        break;
    
      default:
        this.modelAuctionFilter.participant = { value: "all", name:"Все"};
        break;
    }

  }

  public mailToCommercialOffer(item){
    
    this.http.get<Array<string>>(apiServer + "/commercial_offer/"+ item.idAuc + "/" + item.distributerParticipant)
    .subscribe(resp => { 
      // this.mail.participant = distributerParticipant;
      // this.mail.idAuction = code;
      // this.mail.mailTo = "yuliya.grunskaya@grotexmed.com";
      // //this.mail.mailTo = resp["mailTo"];
      // this.mail.mailCopy = resp["mailCopy"];
      // this.mail.mailTopic = resp["mailTopic"];
      // this.mail.mailBody = resp["mailBody"];

      var modal = $('#messageModal');
      modal.find('.mailBody').text(resp["mailBody"]);
      modal.find('.modal-title').text("Получатель " + resp["mailTo"]);
      modal.show();
    });
  }


  getDateYYYYMMDD(to:boolean = false){
    // var dateFrom = new Date().toISOString().slice(0,10);
    // $('#dateAucFrom').val(dateFrom); 
    // this.modelAuctionFilter.dateAucFrom = dateFrom;

    // var dateTo = new Date();
    // dateTo.setMonth(new Date().getMonth() - 1);
    // $('#dateAucTo').val(dateTo.toISOString().slice(0,10)); 
    // this.modelAuctionFilter.dateAucTo = dateTo.toISOString().slice(0,10);


    if(!to){
      var dateTo = new Date();
      dateTo.setMonth(new Date().getMonth() - 1);
      return dateTo.toISOString().slice(0,10);
    }
    else{
      return new Date().toISOString().slice(0,10);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/component/mailing-page/mailing-page.component.ts